import { render, staticRenderFns } from "./aportes.vue?vue&type=template&id=13cf97b2&"
import script from "./aportes.vue?vue&type=script&lang=js&"
export * from "./aportes.vue?vue&type=script&lang=js&"
import style0 from "./aportes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports